import {
  Flex,
  Text,
  useDisclosure,
  AlertInfoIcon,
  CheckIcon,
} from '@cdl/heartbeat-react';
import { InfoModal } from './InfoModal';
import { highlightLinks } from '../../../shared/utils/highligthLinks';

interface Props {
  title: string;
  description: string;
}

export const AnnotationTaskInfo: React.FC<Props> = ({ title, description }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex align='center' onClick={onOpen} cursor='pointer' data-group>
      <AlertInfoIcon
        fontSize='1rem'
        mr='xs'
        sx={{
          _groupHover: {
            color: 'primary.500',
          },
        }}
      />
      <Text maxWidth='25rem' noOfLines={1}>
        {title}
      </Text>
      <InfoModal
        isOpen={isOpen}
        title={title}
        onClose={onClose}
        closeButtonRightIcon={<CheckIcon />}
        withDashedBorder
      >
        {highlightLinks(description)}
      </InfoModal>
    </Flex>
  );
};
